module.exports = __webpack_public_path__ + "static/wix_paypal-890536065af764921bdb78e33eb470a9.svg";